import script from "./behalf-pay.vue?vue&type=script&lang=ts&setup=true"
export * from "./behalf-pay.vue?vue&type=script&lang=ts&setup=true"

import "./behalf-pay.vue?vue&type=style&index=0&id=0089a188&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0089a188"]])

export default __exports__